import React from "react";
import { FormattedMessage } from "react-intl";
import { Field, useFormikContext } from "formik";
import classnames from "classnames";
import {
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fontAwesome from "@fortawesome/free-solid-svg-icons";

function TextField(props) {
  const { isSubmitting, setFieldValue } = useFormikContext();

  return (
    <FormGroup className={classnames(props.classNameFormGroup)}>
      <InputGroup
        className={`custom-valitation-fieldset ${
          props.icon ? "" : "without-icon"
        }
        ${props.errorClass ? props.errorClass : ""}
        `}
      >
        {props.icon ? (
          <InputGroupAddon
            addonType="prepend"
            className="custom-validation-icon-field"
          >
            <InputGroupText>
              {props.fontAwesome || props.icon ? (
                props.fontAwesome ? (
                  <FontAwesomeIcon icon={fontAwesome[props.fontAwesome]} />
                ) : (
                  <i className={props.icon} />
                )
              ) : null}
            </InputGroupText>
          </InputGroupAddon>
        ) : null}
        <FormattedMessage
          id={
            "fields." +
            (props.placeholder ? props.placeholder : props.name)
          }
        >
          {(placeholder) => (
            <Field
              name={props.name}
              value={props.value}
              type="text"
              className={`form-control ${props.isInvalid ? "is-invalid" : ""} ${
                props.isValid ? "is-valid" : ""
              }`}
              placeholder={
                `${placeholder}` + (props.required === true ? " *" : "")
              }
              autoComplete={props.autoComplete}
              id={props.id}
              disabled={isSubmitting}
              onChange={(event) => {
                setFieldValue(event.target.value);
                if (props.onChange) props.onChange(event);
              }}
            />
          )}
        </FormattedMessage>
      </InputGroup>
      {props.isInvalid && props.propsErrMsg && (
        <div className="invalid-feedback">{props.propsErrMsg}</div>
      )}
    </FormGroup>
  );
}

TextField.defaultProps = {
  name: "firstName",
  icon: "",
  autoComplete: "on",
  fontAwesome: "",
  value: "",
  isValid: false,
  isInvalid: false,
  propsErrMsg: "",
  classNameFormGroup: "",
  placeholder: "",
};

export { TextField };
